export class OpportunityPhase {
  id!: number;
  label!: string;

  constructor(data: unknown = {}) {
    Object.assign(this, data);
  }
}
